<header class="page-header">
    <h1>{{'page.audiences.name' | translate | upperFirstLetter }}</h1>
</header>